var moduleMap = {
	"./Channels": () => {
		return Promise.all([__webpack_require__.e(3968), __webpack_require__.e(1687), __webpack_require__.e(1507), __webpack_require__.e(3567), __webpack_require__.e(4143), __webpack_require__.e(4627), __webpack_require__.e(8599), __webpack_require__.e(6004), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(6782), __webpack_require__.e(64), __webpack_require__.e(6869), __webpack_require__.e(2264), __webpack_require__.e(2460), __webpack_require__.e(1669)]).then(() => (() => ((__webpack_require__(72264)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});